import React from 'react'

const CodeIcon = () => {
  return (
    <svg
      width="40"
      height="34"
      viewBox="0 0 40 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.23223 18.7678C0.255922 17.7915 0.255922 16.2085 1.23223 15.2322L8.3033 8.16117C9.27961 7.18486 10.8625 7.18486 11.8388 8.16117C12.8151 9.13748 12.8151 10.7204 11.8388 11.6967L6.53553 17L11.8388 22.3033C12.8151 23.2796 12.8151 24.8625 11.8388 25.8388C10.8625 26.8151 9.27961 26.8151 8.3033 25.8388L1.23223 18.7678ZM24.6868 0.596193C26.0144 0.975504 26.7831 2.35922 26.4038 3.68681L18.4038 31.6868C18.0245 33.0144 16.6408 33.7831 15.3132 33.4038C13.9856 33.0245 13.2169 31.6408 13.5962 30.3132L21.5962 2.3132C21.9755 0.985612 23.3592 0.216883 24.6868 0.596193ZM28.2322 8.16117C29.2085 7.18486 30.7915 7.18486 31.7678 8.16117L38.8388 15.2322C39.8151 16.2086 39.8151 17.7915 38.8388 18.7678L31.7678 25.8388C30.7915 26.8152 29.2085 26.8152 28.2322 25.8388C27.2559 24.8625 27.2559 23.2796 28.2322 22.3033L33.5355 17L28.2322 11.6967C27.2559 10.7204 27.2559 9.13748 28.2322 8.16117Z"
        fill="#C58C5F"
      />
    </svg>
  )
}

export default CodeIcon
